/**
 * 日本語定義ファイル
 */

/**
 * エラーメッセージ
 */
export const error_message = {
    'Network Error': 'ネットワークエラーが発生しました。',
    'ECONNABORTED': 'リクエストがタイムアウトしました。'
}

/**
 * プラン一覧
 */
export const plan_list = {
    'light': 'ライト',
    'standard': 'スタンダード',
    'premium': 'プレミアム',
    'chatplus': 'チャットプラス',
}

/**
 * 見積書種類
 */
export const quotation_type = {
    '1': '総額見積書',
    '2': '個別見積書',
    '3': '更新見積書',
    '4': '総額見積書',
}

/**
 * ODAS
 */

// TODO: cl_client_tblとの重複を省く
// // 未選択値
// let cl_client_tbl_search = {
//     invoice_type: [
//         { value: null, text: '（未選択）' }
//     ]
// }
// // 選択肢追加
// for (const colomun in this.cl_client_tbl) {
//     for (const key in this.cl_client_tbl[colomun]) {
//         cl_client_tbl_search[colomun].push({value: key, test: this.cl_client_tbl[colomun][key]})
//     }
// }
/**
 * 顧客テーブル：検索項目用
 */
export const cl_client_tbl_search = {
    // 電子請求区分
    invoice_type: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '通常請求' },
        { value: 1, text: '電子請求' }
    ],
    // 電子化可否
    e_against_flg: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '電子化可能' },
        { value: 1, text: '電子化不可' }
    ],
    // 支払区分
    payment_type: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '銀行振込' },
        { value: 1, text: '口座振替' },
        { value: 2, text: 'クレジットカード決済' }
    ],
    // 回収月
    collecting_month: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '当月末' },
        { value: 1, text: '翌月末'},
        { value: 2, text: '翌々月末'}
    ],
    // 締日
    closing_day: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '都度請求' },
        { value: 5, text: '5日' },
        { value: 10, text: '10日' },
        { value: 15, text: '15日' },
        { value: 20, text: '20日' },
        { value: 25, text: '25日' },
        { value: 99, text: '末日' }
    ],
    // 税額通知
    tax_note: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '伝票単位' },
        { value: 1, text: '請求書単位' },
        { value: 2, text: '免税' },
        { value: 3, text: '無税' },
        { value: 4, text: '明細単位' },
        { value: 5, text: '明細請求書単位' },
        { value: 6, text: '明細伝票単位' }
    ],
    // 業種コード
    business_code: [
        { value: null, text: '（未選択）' },
        { value: 'A', text: '農業, 林業' },
        { value: 'B', text: '漁業' },
        { value: 'C', text: '鉱業, 採石業, 砂利採取業' },
        { value: 'D', text: '建設業' },
        { value: 'E', text: '製造業' },
        { value: 'F', text: '電気・ガス・熱供給・水道業' },
        { value: 'G', text: '情報通信業' },
        { value: 'H', text: '運輸業, 郵便業' },
        { value: 'I', text: '卸売業, 小売業' },
        { value: 'J', text: '金融業, 保険業' },
        { value: 'K', text: '不動産業, 物品賃貸業' },
        { value: 'L', text: '学術研究, 専門・技術サービス業' },
        { value: 'M', text: '宿泊業, 飲食サービス業' },
        { value: 'N', text: '生活関連サービス業, 娯楽業' },
        { value: 'O', text: '教育, 学習支援業' },
        { value: 'P', text: '医療, 福祉' },
        { value: 'Q', text: '複合サービス事業' },
        { value: 'R', text: 'サービス業（他に分類されないもの）' },
        { value: 'S', text: '公務（他に分類されるものを除く）' },
        { value: 'T', text: '分類不能の産業' }
    ],
    // 販売種別
    sales_channel: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '直販' },
        { value: 1, text: '販売店' }
    ],
    // 削除フラグ
    delete_flg: [
        { text: '有効', value: '0' },
        { text: '削除済み', value: '1' }
    ]
}

/**
 * 顧客テーブル：表示用
 */
export const cl_client_tbl = {
    // 電子請求区分
    // 0:通常請求、1:電子請求
    invoice_type: {
        0: '通常請求',
        1: '電子請求'
    },
    // 支払区分
    // 0:銀行振込、1:口座振替、2:クレジット
    payment_type: {
        0: '銀行振込',
        1: '口座振替',
        2: 'クレジット'
    },
    // 業種コード
    // A:農業, 林業、B:漁業、C:鉱業, 採石業, 砂利採取業、D:建設業、E:製造業、F:電気・ガス・熱供給・水道業、
    // G:情報通信業、H:運輸業, 郵便業、I:卸売業, 小売業、J:金融業, 保険業、K:不動産業, 物品賃貸業
    // L:学術研究, 専門・技術サービス業、M:宿泊業, 飲食サービス業、N:生活関連サービス業, 娯楽業
    // O:教育, 学習支援業、P:医療, 福祉、Q:複合サービス事業、R:サービス業（他に分類されないもの）
    // S:公務（他に分類されるものを除く）、T:分類不能の産業
    business_code: {
        'A': '農業, 林業',
        'B': '漁業',
        'C': '鉱業, 採石業, 砂利採取業',
        'D': '建設業',
        'E': '製造業',
        'F': '電気・ガス・熱供給・水道業',
        'G': '情報通信業',
        'H': '運輸業, 郵便業',
        'I': '卸売業, 小売業',
        'J': '金融業, 保険業',
        'K': '不動産業, 物品賃貸業',
        'L': '学術研究, 専門・技術サービス業',
        'M': '宿泊業, 飲食サービス業',
        'N': '生活関連サービス業, 娯楽業',
        'O': '教育, 学習支援業',
        'P': '医療, 福祉',
        'Q': '複合サービス事業',
        'R': 'サービス業（他に分類されないもの）',
        'S': '公務（他に分類されるものを除く）',
        'T': '分類不能の産業'
    },
    // 削除フラグ
    // 0:有効、1:削除済み
    delete_flg: {
        '0': '有効',
        '1': '削除済み'
    },
    // 販売種別
    // 0:直販、1:代理店
    sales_channel: {
        0: '直販',
        1: '代理店'
    },
    // 請求区分
    //0:定期請求、1:都度請求
    billing_type: {
        0: '定期請求',
        1: '都度請求'
    },
    // 差額請求区分
    // 0:定期請求、1:都度請求
    balance_bill_type: {
        0: '定期請求',
        1: '都度請求'
    },
    // 無償明細出力要否
    // 0:必要、1:不要
    free_bill_flg: {
        0: '必要',
        1: '不要'
    },
    // 回収月
    // 0:当月末、1:翌月末、2:翌々月末
    collecting_month: {
        0: '当月末',
        1: '翌月末',
        2: '翌々月末'
    },
    // 締日
    // 0,5,10,15,20,25日を指定（99:末日）
    closing_day: {
        0: '都度請求',
        5: '5日',
        10: '10日',
        15: '15日',
        20: '20日',
        25: '25日',
        99: '末日'
    },
    // 入金日
    // 1～31、99:末日
    payment_date: {
        1: '1日',
        2: '2日',
        3: '3日',
        4: '4日',
        5: '5日',
        6: '6日',
        7: '7日',
        8: '8日',
        9: '9日',
        10: '10日',
        11: '11日',
        12: '12日',
        13: '13日',
        14: '14日',
        15: '15日',
        16: '16日',
        17: '17日',
        18: '18日',
        19: '19日',
        20: '20日',
        21: '21日',
        22: '22日',
        23: '23日',
        24: '24日',
        25: '25日',
        26: '26日',
        27: '27日',
        28: '28日',
        29: '29日',
        30: '30日',
        31: '31日',
        99: '末日'
    },
    // 納品書コード
    // 0:自動選択、>0:納品書フォーム番号
    statement_code: {
        0: '自動選択'
    },
    // 特定メール拒否
    // 1:広告宣伝メール受信拒否、0:(空)
    mail_refuse_flg: {
        0: '',
        1: '広告宣伝メール受信拒否'
    },
    // 税額通知
    // 0:伝票単位、1:請求書単位、2:免税、3:無税、4:明細単位、5:明細請求書単位、6:明細伝票単位
    tax_note: {
        0: '伝票単位',
        1: '請求書単位',
        2: '免税',
        3: '無税',
        4: '明細単位',
        5: '明細請求書単位',
        6: '明細伝票単位'
    },
    // 消費者端数処理
    // 0:切り捨て、1:四捨五入、2:切り上げ
    tax_round: {
        0: '切り捨て',
        1: '四捨五入',
        2: '切り上げ'
    },
    // 印刷先区分
    // 0:ODASシステム、1:商奉行
    print_dest: {
        0: 'ODASシステム',
        1: '商奉行'
    },
    // 要注意フラグ
    // 1:要注意、0: （空）
    caution_flg: {
        0: '',
        1: '要注意'
    },
    // 商奉行抽出済み
    // 0:未抽出、1:抽出済み
    extracted_flg: {
        0: '未抽出',
        1: '抽出済み'
    },
    // 電子化可否
    // 0:電子化可能、1:電子化不可
    e_against_flg: {
        0: '電子化可能',
        1: '電子化不可'
    },
    // 電子請求抽出済み
    // 0:未抽出、1:抽出済み
    invoice_ext_flg: {
        0: '未抽出',
        1: '抽出済み'
    },
    // 電子請求ID抽出済み
    // 0:未抽出、1:抽出済み
    login_ext_flg: {
        0: '未抽出',
        1: '抽出済み'
    },
    // Salesforce抽出済み
    // 0:未抽出、1:抽出済み
    salesforce_ext_flg: {
        0: '未抽出',
        1: '抽出済み'
    }
}

// TODO: 商品コードと商品名の正式名称を確認する
export const m_item_tbl = {
    'KNEOJST1MB001': {
        'item_name': 'グループウェア desknet\'s NEO',
        'unit': 'ユーザー'
    },
    'KNEOJST1YB001': {
        'item_name': 'グループウェア desknet\'s NEO',
        'unit': 'ユーザー'
    },
    'KAPPJST1MB001': {
        'item_name': '業務アプリ作成ツール AppSuite',
        'unit': 'ユーザー'
    },
    'KAPPJST1YB001': {
        'item_name': '業務アプリ作成ツール AppSuite',
        'unit': 'ユーザー'
    },
    'KWEBJST1MB001': {
        'item_name': 'desknet\'s NEO ウェブ会議',
        'unit': '会議室'
    },
    'KWEBJST1YB001': {
        'item_name': 'desknet\'s NEO ウェブ会議',
        'unit': '会議室'
    },
    'KEXPJST1MB001': {
        'item_name': '交通費・経費精算',
        'unit': 'ユーザー'
    },
    'KEXPJST1YB001': {
        'item_name': '交通費・経費精算',
        'unit': 'ユーザー'
    },
    'KTMCJAC1MS000': {
        'item_name': 'タイムカード＋CLOUZA',
        'unit': 'ユーザー'
    },
    'KTMCJAC1YS000': {
        'item_name': 'タイムカード＋CLOUZA',
        'unit': 'ユーザー'
    },
    'KTMAJAC1MS000': {
        'item_name': 'タイムカード＋CLOUZA（有休管理＋申請承認オプション）',
        'unit': 'ユーザー'
    },
    'KTMAJAC1YS000': {
        'item_name': 'タイムカード＋CLOUZA（有休管理＋申請承認オプション）',
        'unit': 'ユーザー'
    },
    'KHDDJAC1MS000': {
        'item_name': 'ディスク増設',
        'unit': ''
    },
    'KHDDJAC1YS000': {
        'item_name': 'ディスク増設',
        'unit': ''
    },
    'KSYSJAC1MB001': {
        'item_name': 'Sync for smartphones',
        'unit': 'ユーザー'
    },
    'KSYSJAC1YB001': {
        'item_name': 'Sync for smartphones',
        'unit': 'ユーザー'
    },
    'KDRDJAC1MS000': {
        'item_name': "desknet'sドライブ ディスク増設",
        'unit': ''
    },
    'KDRDJAC1YS000': {
        'item_name': "desknet'sドライブ ディスク増設",
        'unit': ''
    },
    'KBATJAC1MS000': {
        'item_name': 'BASIC認証（無償）',
        'unit': ''
    },
    'KBATJAC1YS000': {
        'item_name': 'BASIC認証（無償）',
        'unit': ''
    },
    'KRIPJAC1MS000': {
        'item_name': '接続元IPアドレス制限（無償）',
        'unit': ''
    },
    'KRIPJAC1YS000': {
        'item_name': '接続元IPアドレス制限（無償）',
        'unit': ''
    },
    'KSBDJAC1MS000': {
        'item_name': 'セキュアブラウザ',
        'unit': 'デバイス'
    },
    'KSBDJAC1YS000': {
        'item_name': 'セキュアブラウザ',
        'unit': 'デバイス'
    },
    'KSBNJAC1MS000': {
        'item_name': 'セキュアブラウザ',
        'unit': 'ユーザー'
    },
    'KSBNJAC1YS000': {
        'item_name': 'セキュアブラウザ',
        'unit': 'ユーザー'
    },
    'KCCNJAC1MS000': {
        'item_name': 'クライアント認証',
        'unit': 'デバイス'
    },
    'KCCNJAC1YS000': {
        'item_name': 'クライアント認証',
        'unit': 'デバイス'
    },
    'KMLSJST1MB001': {
        'item_name': 'メールサービス（WebARENA）',
        'unit': 'アカウント'
    },
    'KMLSJST1YB001': {
        'item_name': 'メールサービス（WebARENA）',
        'unit': 'アカウント'
    },
    'KMLSJCB1MB005': {
        'item_name': 'メールサービス（CYBERMAILΣ）',
        'unit': 'アカウント'
    },
    'KMLSJCB1YB005': {
        'item_name': 'メールサービス（CYBERMAILΣ）',
        'unit': 'アカウント'
    },
    'KMLSJCB1MB010': {
        'item_name': 'メールサービス（CYBERMAILΣ）',
        'unit': 'アカウント'
    },
    'KMLSJCB1YB010': {
        'item_name': 'メールサービス（CYBERMAILΣ）',
        'unit': 'アカウント'
    },
    'KMLSJCB1MB050': {
        'item_name': 'メールサービス（CYBERMAILΣ）',
        'unit': 'アカウント'
    },
    'KMLSJCB1YB050': {
        'item_name': 'メールサービス（CYBERMAILΣ）',
        'unit': 'アカウント'
    },
    'KMLSJCB1MB100': {
        'item_name': 'メールサービス（CYBERMAILΣ）',
        'unit': 'アカウント'
    },
    'KMLSJCB1YB100': {
        'item_name': 'メールサービス（CYBERMAILΣ）',
        'unit': 'アカウント'
    },
    'KMLSJCB1MAPEN': {
        'item_name': '添付ファイル暗号化・分離',
        'unit': ''
    },
    'KMLSJCB1YAPEN': {
        'item_name': '添付ファイル暗号化・分離',
        'unit': ''
    },
    'KMLSJCB1MAPLK': {
        'item_name': '情報漏えい対策',
        'unit': ''
    },
    'KMLSJCB1YAPLK': {
        'item_name': '情報漏えい対策',
        'unit': ''
    },
    'KMLSJCB1MAA05': {
        'item_name': 'メールアーカイブ＆監査',
        'unit': ''
    },
    'KMLSJCB1YAA05': {
        'item_name': 'メールアーカイブ＆監査',
        'unit': ''
    },
    'KMLSJCB1MAA07': {
        'item_name': 'メールアーカイブ＆監査',
        'unit': ''
    },
    'KMLSJCB1YAA07': {
        'item_name': 'メールアーカイブ＆監査',
        'unit': ''
    },
    'KMLSJCB1MAA10': {
        'item_name': 'メールアーカイブ＆監査',
        'unit': ''
    },
    'KMLSJCB1YAA10': {
        'item_name': 'メールアーカイブ＆監査',
        'unit': ''
    },
    'KMLSJCB1YASBX': {
        'item_name': 'クラウド型サンドボックス',
        'unit': ''
    },
    'KMLSJCB1MASBX': {
        'item_name': 'クラウド型サンドボックス',
        'unit': ''
    },
    'KCHTJST1YB001': {
        'item_name': 'ChatLuck',
        'unit': 'ユーザー'
    },
    'KCHTJST1MB001': {
        'item_name': 'ChatLuck',
        'unit': 'ユーザー'
    },
    'KCHTJAC1YS001': {
        'item_name': 'ディスク増設',
        'unit': ''
    },
    'KCHTJAC1MS001': {
        'item_name': 'ディスク増設',
        'unit': ''
    },
    'KCTBJAC1MS000': {
        'item_name': 'BASIC認証（無償）',
        'unit': ''
    },
    'KCTBJAC1YS000': {
        'item_name': 'BASIC認証（無償）',
        'unit': ''
    },
    'KCTIJAC1MS000': {
        'item_name': '接続元IPアドレス制限（無償）',
        'unit': ''
    },
    'KCTIJAC1YS000': {
        'item_name': '接続元IPアドレス制限（無償）',
        'unit': ''
    }
}

// TODO: od_order_tblとの重複を省く
/**
 * 注文情報テーブル：検索項目用
 */
export const od_order_tbl_search = {
    // 注文種別
    order_type: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '新規' },
        { value: 1, text: '変更' },
        { value: 2, text: '解約' },
        { value: 3, text: '情報変更' }
    ],
    // 注文処理ステータス
    order_proc_sts: [
        { value: null, text: '（未選択）'},
        { value: 0, text: '未処理' },
        { value: 1, text: '処理中' },
        { value: 2, text: '処理済み' },
        { value: 3, text: 'キャンセル' },
    ],
    // 反映ステータス
    order_ref_sts: [
        { value: null, text: '（未選択）'},
        { value: 0, text: '未反映' },
        { value: 1, text: '反映済み' },
        { value: 2, text: '反映エラー' },
    ]
}

/**
 * 注文情報テーブル：表示用
 */
export const od_order_tbl = {
    // 注文種別
    // 0:新規、1:変更、2:解約、3:情報変更
    order_type: {
        0: '新規',
        1: '変更',
        2: '解約',
        3: '情報変更'
    },
    // クラウド種別
    // 0:サービス利用型、1:ライセンス持込型
    service_type: {
        0: 'サービス利用型',
        1: 'ライセンス持込型'
    },
    // プラン区分
    // 0:月払い、1:年間一括払い
    plan_type: {
        0: '月払い',
        1: '年間一括払い'
    },
    // 役務有無
    // 0:無し、1:有り
    work_type: {
        0: '無し',
        1: '有り'
    },
    // 解約コード
    // 1:'利用頻度が少ない'、2:'自社・他社サーバに移行のため'、3:'サービス内容に不満'、4:'会社方針の為'、
    // 5: '料金が高い'、6: '営業の対応に不満'、7: 'アフターサポートに不満',8: 'その他'
    cancel_code: {
        1: '利用頻度が少ない',
        2: '自社・他社サーバに移行のため',
        3: 'サービス内容に不満',
        4: '会社方針の為',
        5: '料金が高い',
        6: '営業の対応に不満',
        7: 'アフターサポートに不満',
        8: 'その他'
    },
    // 契約反映
    // 0:未反映、1:反映済み、2:反映エラー
    order_ref_sts: {
        0: '未反映',
        1: '反映済み',
        2: '反映エラー'
    },
    // 注文処理
    // 0:未処理、1:処理中、2:処理済み、3:キャンセル
    order_proc_sts: {
        0: '未処理',
        1: '処理中',
        2: '処理済み',
        3: 'キャンセル'
    },
    // NEO持込種別
    // 0:新規、1:既存
    neo_carry_type: {
        0: '新規',
        1: '既存'
    },
    // NEO移行有無
    // 0:無し、1:有り
    neo_carry_m_flg: {
        0: '無し',
        1: '有り'
    },
    // DB持込種別
    // 0:新規、1:無し
    db_carry_type: {
        0: '新規',
        1: '既存'
    },
    // DB移行有無
    // 0:無し、1:有り
    db_carry_m_flg: {
        0: '無し',
        1: '有り'
    },
    // BASIC認証変更
    // 0:無し、1:有り
    basic_auth_chg: {
        0: '無し',
        1: '有り'
    },
    // BASIC認証除外IPアドレス変更
    // 0:無し、1:有り
    basic_except_ip_chg: {
        0: '無し',
        1: '有り'
    },
    // 接続許可IPアドレス変更
    // 0:無し、1:有り
    connect_permit_ip_chg: {
        0: '無し',
        1: '有り'
    },
    // セキュアブラウザ除外IPアドレス変更
    // 0:無し、1:有り
    secure_except_ip_chg: {
        0: '無し',
        1: '有り'
    },
    // クライアント証明除外IPアドレス変更
    // 0:無し、1:有り
    cert_except_ip_chg: {
        0: '無し',
        1: '有り'
    },
}

/**
 * 注文明細テーブル
 */
export const od_order_details_tbl = {
    // 明細種別
    // 0: '新規'、1: '変更'、2: '解約'
    details_type: {
        0: '新規',
        1: '変更',
        2: '解約',
    },
    // 請求区分
    // 0: '定期請求'、1: '都度請求'
    billing_type: {
        0: '定期請求',
        1: '都度請求',
    },
    // 商品区分
    // 0: '売上'、2: '値引き'、3: '雑売'
    // 4: '雑費'、5: '運賃'、6: '摘要'、7: '消費税'
    item_type: {
        0: '売上',
        2: '値引き',
        3: '雑売',
        4: '雑費',
        5: '運賃',
        6: '摘要',
        7: '消費税',
    },
    // 請求単位
    // 0: '一括請求'、1: '1ヶ月毎'、6: '6ヶ月毎'
    // 12: '12ヶ月毎'、24: '24ヶ月毎'、36: '36ヶ月毎'
    billing_period: {
        0: '一括請求',
        1: '1ヶ月毎',
        6: '6ヶ月毎',
        12: '12ヶ月毎',
        24: '24ヶ月毎',
        36: '36ヶ月毎',
    },
    // 売上単位
    // 0: '一括売上'、1: '1ヶ月分割'、6: '6ヶ月分割'
    // 12: '12ヶ月分割'、24: '24ヶ月分割'、36: '36ヶ月分割'
    amount_period: {
        0: '一括売上',
        1: '1ヶ月分割',
        6: '6ヶ月分割',
        12: '12ヶ月分割',
        24: '24ヶ月分割',
        36: '36ヶ月分割',
    },
    // 税区分
    // 1: '標準課税'、2: '非課税'
    tax_kind: {
        1: '標準課税',
        2: '非課税',
    },
    // 税込区分
    // 1: '税抜'、2: '税込'
    tax_included: {
        1: '税抜',
        2: '税込',
    },
    // 請求単位変更フラグ
    // 0: '変更無し'、1: '変更有り'
    billing_period_chg: {
        0: '変更無し',
        1: '変更有り',
    },
    // 反映ステータス
    // 0: '未反映'、1: '反映済み'、2: '反映エラー'
    ref_status: {
        0: '未反映',
        1: '反映済み',
        2: '反映エラー',
    }
}

/**
 * 契約情報テーブル
 */
export const cl_contract_tbl = {
    // 契約状況
    // 1:試用中,2:試用終了,3:申請中,4:サービス中,5:解約申請中,
    // 6:その他,7:通常解約,8:強制解約,9:その他解約,10:取消,11:停止中
    contract_status: {
        1: '試用中',
        2: '試用終了',
        3: '申請中',
        4: 'サービス中',
        5: '解約申請中',
        6: 'その他',
        7: '通常解約',
        8: '強制解約',
        9: 'その他解約',
        10: '取消',
        11: '停止中'
    },
    // 請求月
    // -3:翌々々月,-2:翌々月,-1:翌月,0:当月,1:前月,2:前々月
    billing_month: {
        '-3': '翌々々月',
        '-2': '翌々月',
        '-1': '翌月',
        0: '当月',
        1: '前月',
        2: '前々月'
    },
    // 請求区分
    // 0:定期請求、1:都度請求
    billing_type: {
        0: '定期請求',
        1: '都度請求'
    },
    // 差額請求区分
    // 0:定期請求、1:都度請求
    balance_bill_type: {
        0: '定期請求',
        1: '都度請求'
    },
    // 解約理由
    // 1:利用頻度が少ない,2:自社・他社サーバに移行のため,3:サービス内容に不満,
    // 4:会社方針の為,5:料金が高い,6:営業の対応に不満,7:アフターサポートに不満,8:その他
    cancel_code: {
        1: '利用頻度が少ない',
        2: '自社・他社サーバに移行のため',
        3: 'サービス内容に不満',
        4: '会社方針の為',
        5: '料金が高い',
        6: '営業の対応に不満',
        7: 'アフターサポートに不満',
        8: 'その他'
    },
    // 業務状況
    // 0:未受注、1:受注済み、2:出荷済み
    operation_status: {
        0: '未受注',
        1: '受注済み',
        2: '出荷済み'
    },
    // 試使用有り
    // 1:有り、0:無し
    trial_existence_flg: {
        1: '有り',
        0: '無し'
    },
    // 削除フラグ
    // 1:削除済、0:有効
    delete_flg: {
        1: '削除済',
        0: '有効'
    },
    // 作業状況
    // 0:着手前、1:作業中、2:完了
    work_status: {
        0: '着手前',
        1: '作業中',
        2: '完了'
    },
    // ドメイン取得状況
    // 0:-、1:新規、2:取得済
    domain_status: {
        0: '-',
        1: '新規',
        2: '取得済'
    },
    // 解約後ドメイン処理
    // 0:-、1:移設、2:破棄
    domain_cancel_code: {
        0: '-',
        1: '移設',
        2: '破棄'
    },
    // ネームサーバ
    // 0:-、1:ComStage通常、2:個別対応
    name_server_code: {
        0: '-',
        1: 'ComStage通常',
        2: '個別対応'
    },
    // ドメイン管理
    // 0:-、1:当社、2:お客様
    domain_admin_code: {
        0: '-',
        1: '当社',
        2: 'お客様'
    },
    // レジストラ
    // 0:未設定、1:GMOソリス(TWO TOWN)、2:GMOソリス(JPRS)、
    // 3:ファーストサーバー、4:お客様、5:その他
    registrar_code: {
        0: '未設定',
        1: 'GMOソリス(TWO TOWN)',
        2: 'GMOソリス(JPRS)',
        3: 'ファーストサーバー',
        4: 'お客様',
        5: 'その他'
    },
    // DNS管理
    // 0:-、1:当社、2:お客様
    dns_admin_code: {
        0: '-',
        1: '当社',
        2: 'お客様'
    },
    // サーバ利用状況
    // 0:なし、1:両方、2:HP、3:メール
    server_status: {
        0: 'なし',
        1: '両方',
        2: 'HP',
        3: 'メール'
    },
    // 証明書CA局
    // 0:ジオトラスト、1:ベリサイン、2:ビートラステッド
    ca_code: {
        0: 'ジオトラスト',
        1: 'ベリサイン',
        2: 'ビートラステッド'
    }
}

/**
 * クレジットカード情報テーブル
 */
export const cl_credit_card_tbl = {
    // 登録ステータス
    reg_sts: {
        0: '新規登録',
        1: '確認中',
        2: '登録完了',
        3: '廃止',
        4: '削除'
    },
    // エラー処理STS
    error_sts: {
        0: '正常',
        1: '決済エラー',
        2: '確認中',
        3: '確認完了'
    },
    // 有効性チェック結果
    card_sts: {
        0: '有効性OK',
        1: '有効性NG',
        2: 'カード会社照会エラー',
        3: '請求停止',
        4: 'カード会社契約無し',
        5: '有効性非対応カード',
        6: 'ペイジェント照合エラー',
        X: '未確認'
    }
}

/**
 * 顧客担当者テーブル
 */
export const cl_client_person_tbl = {
    // 種別
    // 0:社内、1:社外
    person_type: {
        0: '社内',
        1: '社外'
    },
    // 要注意
    // 1:要注意、0:(空)
    caution_flg: {
        0: '',
        1: '要注意'
    },
    // 特定メール拒否フラグ
    // 1:広告宣伝メール受信拒否、0:(空)
    mail_refuse_flg: {
        0: '',
        1: '広告宣伝メール受信拒否'
    },
    // 削除フラグ
    // 1:削除済、0:有効
    delete_flg: {
        0: '有効',
        1: '削除済'
    }
}

/**
 * 振替口座テーブル
 */
export const cl_transfer_account_tbl = {
    // 金融機関種別
    // 0:民間金融機関、1:郵便局
    bank_type: {
        0: '民間金融機関',
        1: '郵便局'
    },
    // 預金種別
    // 1:普通、2:当座、3:納税準備、4:従業員、9:その他
    deposit_type: {
        1: '普通',
        2: '当座',
        3: '納税準備',
        4: '従業員',
        9: 'その他'
    },
    // 振替新規コード
    // 0:継続請求、1:新規請求
    newly_code: {
        0: '継続請求',
        1: '新規請求'
    },
    // 仮登録フラグ
    // 0:本登録、1:仮登録中
    temporary_flg: {
        0: '本登録',
        1: '仮登録中'
    },
    // 抽出済み
    // 0:未抽出、1:抽出済み
    extracted_flg: {
        0: '未抽出',
        1: '抽出済み'
    }
}

/**
 * 契約明細テーブル
 */
export const cl_contract_details_tbl = {
    // 有効フラグ
    // 1:有効、0:無効、2:保留
    effective_flg: {
        1: '有効',
        0: '無効',
        2: '保留'
    },
    // 商品区分
    // 0:売上、2:値引き、3:雑売、4:雑費、5:運賃、6:摘要、7:消費税
    item_type: {
        0: '売上',
        2: '値引き',
        3: '雑売',
        4: '雑費',
        5: '運賃',
        6: '摘要',
        7: '消費税'
    },
    // 税込区分
    // 1:税抜、2:税込
    tax_included: {
        1: '税抜',
        2: '税込'
    },
    // 税区分
    // 1:標準課税、2:非課税
    tax_kind: {
        1: '標準課税',
        2: '非課税'
    },
    // 請求単位
    // 0:一括請求、1:1ヶ月毎、6:6ヶ月毎、12:12ヶ月毎、24:24ヶ月毎、36:36ヶ月毎
    billing_period: {
        0: '一括請求',
        1: '1ヶ月毎',
        6: '6ヶ月毎',
        12: '12ヶ月毎',
        24: '24ヶ月毎',
        36: '36ヶ月毎'
    },
    // 売上単位
    // 0:一括売上、1:1ヶ月分割、6:6ヶ月分割、12:12ヶ月分割、24:24ヶ月分割、36:36ヶ月分割
    amount_period: {
        0: '一括売上',
        1: '1ヶ月分割',
        6: '6ヶ月分割',
        12: '12ヶ月分割',
        24: '24ヶ月分割',
        36: '36ヶ月分割'
    },
    // 端末認証
    // 01:端末認証なし、02:端末認証あり
    secure_browser_terminal: {
        '01': '端末認証 : なし',
        '02': '端末認証 : あり'
    },
    // 契約種別
    // 0:月払い、1:年間一括払い
    bill_period: {
        0: '月払い',
        1: '年間一括払い'
    }
}

/**
 * サーバテーブル
 */
export const fc_server_tbl = {
    // サーバ種別
    // 0:共用,1:専用
    server_type: {
        0: '共用',
        1: '専用'
    }
}

/**
 * クライアント証明書割当テーブル
 */
export const cl_cert_alloc_tbl = {
    // 失効フラグ
    // 0:有効、1:失効
    invalid_flg: {
        0: '有効',
        1: '失効'
    }
}

/**
 * 利用製品テーブル
 */
export const cl_facility_product_tbl = {
    // 無制限フラグ
    // 0:ユーザ数、1:無制限
    user_count_flg: {
        0: 'ユーザ数',
        1: '無制限'
    },
    // ライセンスキー発行ステータス
    // 0:未申請、1:申請中、2:発行済み
    license_issue_sts: {
        0: '未申請',
        1: '申請中',
        2: '発行済み'
    }
}

/**
 * 都度請求明細テーブル
 */
export const sl_on_demand_billing_tbl = {
    // 請求対象
    // 1:請求対象、0:請求対象外
    effective_flg: {
        1: '請求対象',
        0: '請求対象外'
    },
    // 請求済
    // 1:請求済み、0:未請求
    billed_flg: {
        1: '請求済み',
        0: '未請求'
    },
    // 商品区分
    // 0:売上、2:値引き、3:雑売、4:雑費、5:運賃、6:摘要
    item_type: {
        0: '売上',
        2: '値引き',
        3: '雑売',
        4: '雑費',
        5: '運賃',
        6: '摘要'
    },
    // 税込区分
    // 1:税抜、2:税込
    tax_included: {
        1: '税抜',
        2: '税込'
    },
    // 税区分
    // 1:標準課税、2:非課税
    tax_kind: {
        1: '標準課税',
        2: '非課税'
    },
    // 売上単位
    // 0:一括売上、1:1ヶ月分割、6:6ヶ月分割、12:12ヶ月分割、24:24ヶ月分割、36:36ヶ月分割
    amount_period: {
        0: '一括売上',
        1: '1ヶ月分割',
        6: '6ヶ月分割',
        12: '12ヶ月分割',
        24: '24ヶ月分割',
        36: '36ヶ月分割'
    }
}

/**
 * 業務
 */

/**
 * お客様テーブル：検索項目用
 */
export const ut_user_tbl_search = {
    // 言語コード
    language_code: [
        { value: null, text: '（未選択）' },
        { value: 'eng', text: '英語' },
        { value: 'jpn', text: '日本語' }
    ],
    // 都道府県
    address1: [
        { value: 1, text: '北海道' },
        { value: 2, text: '青森県' },
        { value: 3, text: '岩手県' },
        { value: 4, text: '宮城県' },
        { value: 5, text: '秋田県' },
        { value: 6, text: '山形県' },
        { value: 7, text: '福島県' },
        { value: 8, text: '茨城県' },
        { value: 9, text: '栃木県' },
        { value: 10, text: '群馬県' },
        { value: 11, text: '埼玉県' },
        { value: 12, text: '千葉県' },
        { value: 13, text: '東京都' },
        { value: 14, text: '神奈川県' },
        { value: 15, text: '新潟県' },
        { value: 16, text: '富山県' },
        { value: 17, text: '石川県' },
        { value: 18, text: '福井県' },
        { value: 19, text: '山梨県' },
        { value: 20, text: '長野県' },
        { value: 21, text: '岐阜県' },
        { value: 22, text: '静岡県' },
        { value: 23, text: '愛知県' },
        { value: 24, text: '三重県' },
        { value: 25, text: '滋賀県' },
        { value: 26, text: '京都府' },
        { value: 27, text: '大阪府' },
        { value: 28, text: '兵庫県' },
        { value: 29, text: '奈良県' },
        { value: 30, text: '和歌山県' },
        { value: 31, text: '鳥取県' },
        { value: 32, text: '島根県' },
        { value: 33, text: '岡山県' },
        { value: 34, text: '広島県' },
        { value: 35, text: '山口県' },
        { value: 36, text: '徳島県' },
        { value: 37, text: '香川県' },
        { value: 38, text: '愛媛県' },
        { value: 39, text: '高知県' },
        { value: 40, text: '福岡県' },
        { value: 41, text: '佐賀県' },
        { value: 42, text: '長崎県' },
        { value: 43, text: '熊本県' },
        { value: 44, text: '大分県' },
        { value: 45, text: '宮崎県' },
        { value: 46, text: '鹿児島県' },
        { value: 47, text: '沖縄県' }
    ],
    // クラウド理由
    saas_user_flg: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '通常' },
        { value: 1, text: 'クラウド' }
    ],
    // 官公庁
    office_flg: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '一般' },
        { value: 1, text: '官公庁' }
    ],
    // 業種
    business_type: [
        { value: null, text: '（未選択）' },
        { value: 'A', text: '農業, 林業' },
        { value: 'B', text: '漁業' },
        { value: 'C', text: '鉱業, 採石業, 砂利採取業' },
        { value: 'D', text: '建設業' },
        { value: 'E', text: '製造業' },
        { value: 'F', text: '電気・ガス・熱供給・水道業' },
        { value: 'G', text: '情報通信業' },
        { value: 'H', text: '運輸業, 郵便業' },
        { value: 'I', text: '卸売業, 小売業' },
        { value: 'J', text: '金融業, 保険業' },
        { value: 'K', text: '不動産業, 物品賃貸業' },
        { value: 'L', text: '学術研究, 専門・技術サービス業' },
        { value: 'M', text: '宿泊業, 飲食サービス業' },
        { value: 'N', text: '生活関連サービス業, 娯楽業' },
        { value: 'O', text: '教育, 学習支援業' },
        { value: 'P', text: '医療, 福祉' },
        { value: 'Q', text: '複合サービス事業' },
        { value: 'R', text: 'サービス業（他に分類されないもの）' },
        { value: 'S', text: '公務（他に分類されるものを除く）' },
        { value: 'T', text: '分類不能の産業' },
        { value: 'X', text: '（未登録）' }
    ],
    // 電子請求区分
    invoice_type: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '通常請求' },
        { value: 1, text: '電子請求' }
    ],
    // 配送区分
    distribution_type: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '通常納品' },
        { value: 1, text: '電子納品' }
    ],
    // 電子化可否
    e_against_flg: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '電子化可能' },
        { value: 1, text: '電子化不可' }
    ],
    // 有効フラグ
    effective_flg: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '無効' },
        { value: 1, text: '有効' }
    ],
    // 利用状況
    using_sts: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '利用中' },
        { value: 1, text: '利用停止' }
    ],
    // サーバ種別
    vs_flg: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '物理サーバ' },
        { value: 1, text: '仮想サーバ' }
    ],
}

/**
 * お客様テーブル：表示用
 */
export const ut_user_tbl = {
    // 業種
    // A:農業, 林業、B:漁業、C:鉱業, 採石業, 砂利採取業、D:建設業、E:製造業、F:電気・ガス・熱供給・水道業、
    // G:情報通信業、H:運輸業, 郵便業、I:卸売業, 小売業、J:金融業, 保険業、K:不動産業, 物品賃貸業
    // L:学術研究, 専門・技術サービス業、M:宿泊業, 飲食サービス業、N:生活関連サービス業, 娯楽業
    // O:教育, 学習支援業、P:医療, 福祉、Q:複合サービス事業、R:サービス業（他に分類されないもの）
    // S:公務（他に分類されるものを除く）、T:分類不能の産業
    business_type: {
        'A': '農業, 林業',
        'B': '漁業',
        'C': '鉱業, 採石業, 砂利採取業',
        'D': '建設業',
        'E': '製造業',
        'F': '電気・ガス・熱供給・水道業',
        'G': '情報通信業',
        'H': '運輸業, 郵便業',
        'I': '卸売業, 小売業',
        'J': '金融業, 保険業',
        'K': '不動産業, 物品賃貸業',
        'L': '学術研究, 専門・技術サービス業',
        'M': '宿泊業, 飲食サービス業',
        'N': '生活関連サービス業, 娯楽業',
        'O': '教育, 学習支援業',
        'P': '医療, 福祉',
        'Q': '複合サービス事業',
        'R': 'サービス業（他に分類されないもの）',
        'S': '公務（他に分類されるものを除く）',
        'T': '分類不能の産業'
    },
    // 官公庁フラグ
    // 0:標準、1:官公庁用
    office_flg: {
        0: '標準',
        1: '官公庁用'
    },
    // 要注意フラグ
    // 0:通常、1:注意
    caution_flg: {
        0: '通常',
        1: '注意'
    },
    // ユーザ種別
    // 0:通常、1: クラウドユーザ
    saas_user_flg: {
        0: '通常',
        1: 'クラウドユーザ'
    },
    // 電子化可否
    // 0:電子化可能、1: 電子化不可
    e_against_flg: {
        0: '電子化可能',
        1: '電子化不可'
    },
    // 請求区分
    // 0:通常請求、1:電子請求
    invoice_type: {
        0: '通常請求',
        1: '電子請求'
    },
    // 配送区分
    // 0:通常納品、1:電子納品
    distribution_type: {
        0: '通常納品',
        1: '電子納品'
    },
    // 抽出済みフラグ
    // 0:未抽出、1:抽出済
    extracted_flg: {
        0: '未抽出',
        1: '抽出済み'
    },
    // 電子請求抽出済みフラグ
    // 0:未抽出、1:抽出済
    invoice_ext_flg: {
        0: '未抽出',
        1: '抽出済み'
    },
    // 電子請求ログイン抽出済みフラグ
    // 0:未抽出、1:抽出済
    login_ext_flg: {
        0: '未抽出',
        1: '抽出済み'
    },
    // 直送先：言語コード
    // jpn:日本語、eng:英語
    language_code: {
        jpn: '日本語',
        eng: '英語',
    },
    // 有効フラグ
    // 0:無効、1:有効
    effective_flg: {
        0: '無効',
        1: '有効'
    },
    // salesforce抽出済み
    // 0:未抽出、1:抽出済み
    salesforce_ext_flg: {
        0: '未抽出',
        1: '抽出済み'
    }
}

/**
 * 注文書テーブル：検索項目用
 */
export const ot_accept_tbl_search = {
    // 受付ステータス
    accept_sts: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '入力中' },
        { value: 1, text: '受付完了' },
        { value: 2, text: '保留' },
        { value: 3, text: 'キャンセル' }
    ],
    // 保留理由
    hold_reason: [
        { value: null, text: '（未選択）' },
        { value: 1, text: '申請書不備' },
        { value: 2, text: '申請書待' },
        { value: 3, text: '注文書不備' },
        { value: 4, text: '注文書待' },
        { value: 5, text: 'WF申請中' },
        { value: 6, text: 'その他' }
    ],
    // 受注登録STS
    order_reg_sts: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '未登録' },
        { value: 1, text: '登録済' }
    ]
}

/**
 * 注文書テーブル：表示用
 */
export const ot_accept_tbl = {
    // 受付ステータス
    // 0:入力中、1:受付完了、2:保留、3:キャンセル
    accept_sts: {
        0: '入力中',
        1: '受付完了',
        2: '保留',
        3: 'キャンセル',
    },
    // 保留理由
    // 1:申請書不備、2:申請書待ち、3:注文書不備、4:注文書待ち、5:WF申請中、6:その他
    hold_reason: {
        1: '申請書不備',
        2: '申請書待ち',
        3: '注文書不備',
        4: '注文書待ち',
        5: 'WF申請中',
        6: 'その他',
    },

    // 受注ステータス
    // 0:未登録、1:登録済
    order_reg_sts: {
        0: '未登録',
        1: '登録済',
    },

    // 受注区分
    // 0:直接販売、1:販売店販売
    order_kbn: {
        0: '直接販売',
        1: '販売店販売',
    },
}

/**
 * 受注テーブル：検索項目用
 */
export const ot_order_tbl_search = {
    // 受注ステータス
    order_status: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '入力中' },
        { value: 1, text: '受注入力完了' },
        { value: 2, text: 'キャンセル' }
    ],
    // 売上ステータス
    sales_status: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '未売上' },
        { value: 1, text: '売上済' },
        { value: 2, text: '一部売上' }
    ],
    // 受注区分
    order_kbn: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '直接販売' },
        { value: 1, text: '販売店販売' }
    ],
    // 支払区分
    pay_kbn: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '掛売上' },
        { value: 1, text: '現金売上' },
        { value: 2, text: 'クレジット' }
    ],
    // 言語コード
    lang_code: [
        { value: null, text: '（未選択）' },
        { value: 'jpn', text: '日本語' },
        { value: 'eng', text: '英語' }
    ],
    // 付箋
    tag_cd: [
        { value: null, text: '（未選択）' },
        { value: 0, text: '赤' },
        { value: 1, text: '青' },
        { value: 2, text: '黄' },
        { value: 3, text: '橙' },
        { value: 4, text: '緑' },
        { value: 5, text: '紫' }
    ]
}

/**
 * 受注テーブル：表示用
 */
export const ot_order_tbl = {
    // 受注ステータス
    // 0:入力中、1:受注入力完了、2:キャンセル
    order_status: {
        0: '入力中',
        1: '受注入力完了',
        2: 'キャンセル'
    },

    // 売上ステータス
    // 0:未売上、1:売上済、2:一部売上
    sales_status: {
        0: '未売上',
        1: '売上済',
        2: '一部売上'
    },

    // 受注区分
    // 0:直接販売、1:販売店販売
    order_kbn: {
        0: '直接販売',
        1: '販売店販売',
    },

    // 請求要否
    // 0:通常請求、1:請求不要
    billing_flg: {
        0: '通常請求',
        1: '請求不要',
    },

    // 電子請求区分
    // 0:通常請求、1:電子請求
    invoice_type: {
        0: '通常請求',
        1: '電子請求',
    },

    // 消費税端数処理
    // 0:切上げ、1:四捨五入、2:切捨て
    tax_round: {
        0: '切上げ',
        1: '四捨五入',
        2: '切捨て'
    },

    // 税額通知
    // 0：伝票単位、1：請求書単位、2：免税、3：無税、4：明細単位、5：明細請求書単位、6：明細伝票単位
    tax_note: {
        0: '伝票単位',
        1: '請求書単位',
        2: '免税',
        3: '無税',
        4: '明細単位',
        5: '明細請求書単位',
        6: '明細伝票単位',
    },

    // 予定支払区分
    // 0:掛売上、1:現金売上、2:クレジット
    pay_kbn: {
        0: '掛売上',
        1: '現金売上',
        2: 'クレジット',
    },

    // 領収書発行フラグ
    // 0:領収書不要、1:領収書必要
    receipt_flg: {
        0: '領収書不要',
        1: '領収書必要',
    },

    // 官公庁フラグ
    // 0:一般用、1:官公庁用
    office_flg: {
        0: '一般用',
        1: '官公庁用',
    },

    // 直送先：複写元コード
    // 0:エンド（請求先）、1:販売店、2:販売店支店、3:販売店物流、4:二次販社、5:エンド（契約先）、8:配送先
    direct_source: {
        0: 'エンド（請求先）',
        1: '販売店',
        2: '販売店支店',
        3: '販売店物流',
        4: '二次販社',
        5: 'エンド（契約先）',
        8: '配送先',
    },

    // 直送先：言語コード
    // jpn:日本語、eng:英語
    direct_lang_code: {
        jpn: '日本語',
        eng: '英語',
    },

    // 配送先：保留フラグ
    // 0:通常、1:保留中
    ship_hold_flg: {
        0: '通常',
        1: '保留中',
    },

    // 配送先：複写元コード
    // 0:エンド（請求先）、1:販売店、2:販売店支店、3:販売店物流、4:二次販社、5:エンド（契約先）、9:直送先
    ship_source: {
        0: 'エンド（請求先）',
        1: '販売店',
        2: '販売店支店',
        3: '販売店物流',
        4: '二次販社',
        5: 'エンド（契約先）',
        9: '直送先',
    },

    // 配送先：言語コード
    // jpn:日本語、eng:英語
    ship_lang_code: {
        jpn: '日本語',
        eng: '英語',
    },

    // 受注抽出済フラグ
    // 0:未抽出、1:抽出済
    order_extracted_flg: {
        0: '未抽出',
        1: '抽出済',
    },
}

/**
 * 受注明細テーブル
 */
export const ot_order_details_tbl = {
    // 受注ステータス（明細）
    // 0:入力中、1:受注入力完了、2:受注キャンセル
    order_status: {
        0: '入力中',
        1: '受注入力完了',
        2: '受注キャンセル',
    },

    // 売上区分
    // 0:売上、1:返品、2:値引、3:雑売、4:雑費、5:運賃、6:摘要、7:消費税
    sales_type: {
        0: '売上',
        1: '返品',
        2: '値引',
        3: '雑売',
        4: '雑費',
        5: '運賃',
        6: '摘要',
        7: '消費税',
    },

    // 商品タイプ
    // 0:通常,1:保守,2:売切り,3:その他,4:利用,5:オプション,6:サービス
    i_type: {
        0: '通常',
        1: '保守',
        2: '売切り',
        3: 'その他',
        4: '利用',
        5: 'オプション',
        6: 'サービス',
    },

    // 無制限フラグ
    // 0:ユーザ数(摘要含む)、1:無制限
    user_count_flg: {
        0: 'ユーザ数(摘要含む)',
        1: '無制限',
    },

    // 課税区分
    // 0:不課税、1:標準課税、2:非課税、3:免税
    tax_class: {
        0: '不課税',
        1: '標準課税',
        2: '非課税',
        3: '免税',
    },

    // 税込区分
    // 1:税抜、2:税込
    tax_kubun: {
        1: '税抜',
        2: '税込',
    },

    // 出荷ステータス
    // 0:未出荷、1:報告書待、2:保留、3:完了
    dv_sts: {
        0: '未出荷',
        1: '報告書待',
        2: '保留',
        3: '完了',
    },

    // 計上区分
    // 0:計上、1:非計上
    sum_up_type: {
        0: '計上',
        1: '非計上',
    },

    // 付箋コード
    // 0:赤、1:青、2:黄、3:橙、4:緑、5:紫
    tag_cd: {
        0: '赤',
        1: '青',
        2: '黄',
        3: '橙',
        4: '緑',
        5: '紫',
    },

    // 納品種別
    // 0:通常納品、1:電子納品、2:配送不要
    delivery_type: {
        0: '通常納品',
        1: '電子納品',
        2: '配送不要',
    },

    // 売上ステータス
    // 0:未売上、1:売上済
    sales_status: {
        0: '未売上',
        1: '売上済',
    },
}

/**
 * 製品テーブル
 */
export const pt_product_tbl = {
    // 商品タイプ
    // 0:通常,1:保守,2:売切り,3:その他,4:利用,5:オプション,6:サービス
    i_type: {
        0: '通常',
        1: '保守',
        2: '売切り',
        3: 'その他',
        4: '利用',
        5: 'オプション',
        6: 'サービス',
    },

    // 無償保守フラグ
    // 0:通常製品、1:無償保守
    free_support_flg: {
        0: '通常製品',
        1: '無償保守',
    },

    // 無制限フラグ
    // 0:ユーザ数、1:無制限
    user_count_flg: {
        0: 'ユーザ数',
        1: '無制限',
    },

    // 印刷済みフラグ
    // 1:製品証書印刷済み、0:未印刷
    printed_flg: {
        0: '未印刷',
        1: '製品証書印刷済み',
    },

    // 無償保守有無フラグ
    // 0:通常製品、1:無償保守
    free_support_contain_flg: {
        0: '無償保守なし',
        1: '無償保守あり',
    },

    // 印刷済みフラグ
    // 1:保守証書印刷済み、0:未印刷
    m_printed_flg: {
        0: '未印刷',
        1: '保守証書印刷済み',
    },

    // 有効フラグ
    // 1:有効、0:無効
    effective_flg: {
        0: '無効',
        1: '有効',
    },
}

/**
 * お客様利用環境テーブル
 */
export const ut_user_server_tbl = {
    // お客様コード登録区分
    // 00:新規、01:変更
    user_code_entry_kbn: {
        '00': '新規',
        '01': '変更',
    },

    // 仮想環境
    // 0:物理環境、1:仮想環境
    vs_flg: {
        0: '物理環境',
        1: '仮想環境',
    },
}

/**
 * お客様利用商品種別テーブル
 */
 export const ut_user_i_syu_tbl = {
    // ユーザ数無制限フラグ
    // 0:ユーザ数、1:無制限
    user_count_flg: {
        0: 'ユーザ数',
        1: '無制限'
    },

    // 利用ステータス
    // 0:利用中、1:利用停止
    using_sts: {
        0: '利用中',
        1: '利用停止'
    },

    // 利用停止理由
    // 01:ASPに移行、02:ODASに移行、03:他社利用、04:その他
    stop_reason: {
        '01': 'ASPに移行',
        '02': 'ODASに移行',
        '03': '他社利用',
        '04': 'その他'
    }
}

/**
 * ライセンスキー発行テーブル
 */
export const ut_license_issue_tbl = {
    // キー種別
    // 0:暫定、1:正式
    license_syu: {
        0: '暫定',
        1: '正式',
    },

    // 商品タイプ
    // 0:通常,1:保守,2:売切り,3:その他,4:利用,5:オプション,6:サービス
    i_type: {
        0: '通常',
        1: '保守',
        2: '売切り',
        3: 'その他',
        4: '利用',
        5: 'オプション',
        6: 'サービス',
    },

    // キー発行申請ステータス
    // 1:受付済、2:申請済、3:発行済、4:送信済
    issue_sts: {
        1: '受付済',
        2: '申請済',
        3: '発行済',
        4: '送信済',
    },

    // ライセンスキー発行区分
    // 0:新規発行、1:追加発行、2:再発行、3:更新発行
    license_issue_kbn: {
        0: '新規発行',
        1: '追加発行',
        2: '再発行',
        3: '更新発行',
    },

    // 無制限フラグ
    // 0:ユーザ数、1:無制限
    user_count_flg: {
        0: 'ユーザ数',
        1: '無制限',
    },

    // 申請者：キー送付方法
    // 0:メール、1:オンライン
    key_send_way: {
        0: 'メール',
        1: 'オンライン',
    },

    // 申請者：キー送付先(TO)区分
    // 0:エンドユーザ、1:販売店、2:無し
    key_dest_kind_to: {
        0: 'エンドユーザ',
        1: '販売店',
        2: '無し',
    },

    // 申請者：キー送付先(CC)区分
    // 0:エンドユーザ、1:販売店、2:無し
    key_dest_kind_cc: {
        0: 'エンドユーザ',
        1: '販売店',
        2: '無し',
    },

    // 申請者：キー申請方法
    // 0:WEB、1:FAX、2:メール、3:その他
    key_req_way: {
        0: 'WEB',
        1: 'FAX',
        2: 'メール',
        3: 'その他',
    },

    // 直送先：言語コード
    // jpn:日本語、eng:英語
    language_code: {
        jpn: '日本語',
        eng: '英語',
    },

    // 保守対象フラグ
    // 0:保守有効、1:保守期限切れ
    no_support_flg: {
        0: '保守有効',
        1: '保守期限切れ',
    },
}

/**
 * お客様担当者テーブル
 */
export const ut_user_person_tbl = {
    // 担当者：担当者社外フラグ
    // 0:社内、1:社外
    outside_flg: {
        0: '社内',
        1: '社外',
    },

    // メール送信エラー
    // 0:正常、1:送信エラー
    mail_error: {
        0: '正常',
        1: '送信エラー',
    },

    // メール案内メール要否
    // 0:メール要、1:案内メール不要
    mail_no_need: {
        0: 'メール要',
        1: '案内メール不要',
    },

    // メール受信拒否
    // 0:メール許可、1:メール拒否
    mail_refuse: {
        0: 'メール許可',
        1: 'メール拒否',
    },

    // 有効フラグ
    // 1:有効、0:無効
    effective_flg: {
        0: '無効',
        1: '有効',
    },

}

/**
 * お客様担当者コンタクト履歴テーブル
 */
export const ut_user_contact_tbl = {
    // コンタクト種別
    // 1：注文(ライセンス)、2：注文(サポート)、3：ライセンス申請、4：営業問い合わせ、5：サービス問い合わせ、6：マーケメール送信、7：サービスメール送信、8：営業メール送信
    contact_type: {
        1: '注文(ライセンス)',
        2: '注文(サポート)',
        3: 'ライセンス申請',
        4: '営業問い合わせ',
        5: 'サービス問い合わせ',
        6: 'マーケメール送信',
        7: 'サービスメール送信',
        8: '営業メール送信',
    },
}
